/**
 * Punto de extensión de la página pública de validación de datos
 * (VerifyEmailPage): el PROYECTO puede reemplazar, para una entidad, el
 * formulario genérico (ExternalValidationForm) por una pantalla propia. El
 * generador emite SIEMPRE este mismo contenido estable, así el merge base→develop
 * preserva la versión llenada (mismo contrato que externalValidationExtras.tsx).
 *
 * La clave es el nombre de la entidad (el sourceEntity de la solicitud, por
 * ejemplo "AuthorComposer"); el valor, el componente. Recibe
 * ExternalValidationPageProps (externalValidationTypes.ts, también exportado por
 * VerifyEmailPage.tsx): las credenciales del enlace (vid, sig), lo que devolvió
 * /api/public/verify-email/info (info, con entityName), la empresa (tenantInfo),
 * el idioma de la página y onSubmitted.
 *
 * La pantalla propia confirma con la MISMA ruta que el formulario genérico, POST
 * /api/public/external-validation/submit con { vid, sig, data }: el server aplica
 * todas las validaciones del guardado normal. Con la respuesta exitosa llama a
 * onSubmitted(), o onSubmitted({ changes, tenantInfo }) para que la página
 * muestre la cuenta de cambios, y la página muestra la confirmación.
 *
 * NO EDITAR este stub en el generador: cualquier cambio acá conflictúa con
 * todos los proyectos que lo hayan llenado.
 */
import type { ComponentType } from 'react';
import type { ExternalValidationPageProps } from './externalValidationTypes';
import { AuthorValidationPage } from "./authorValidation/AuthorValidationPage";

// Lleno por Jupiter: los autores validan sus datos con su DNI, en pasos.
export const externalValidationPages: Partial<Record<string, ComponentType<ExternalValidationPageProps>>> = {
  AuthorComposer: AuthorValidationPage,
};
